import {
  PaymentStatementRefundItem,
  PaymentStatementSettlement,
  PaymentStatementStatus,
  RefundData,
} from './paymentStatement';
import RefundLog, { RefundActor } from './refundLog';

export interface SalesChannelOrderRefund {
  receiptUrl?: string;
  amount?: number;
  billingAmount?: number;
  data?: (RefundData | RefundLog)[];
  createdAt?: Date;
  updatedAt?: Date;
  requestUser?: {
    id: string;
    name?: string;
    nickname?: string;
    ip?: string;
    requestedBy: RefundActor;
  };
  purchases?: PaymentStatementRefundItem[];
  requestedAmount?: number;
  acceptedAmount?: number;
  refundedAt?: Date;
  requestedAt?: Date;
  acceptedAt?: Date;
  deniedAt?: Date;
  canceledAt?: Date;
}

export enum SalesChannelsType {
  NAVER_STORE = 'naver-store',
  KAKAO_RESERVATION = 'kakao-reservation',
  INBOUND_APP = 'inbound-app',
  INBOUND_NAVER = 'inbound-naver',
  IGOGO = 'igogo',
  BENEPIA = 'benepia',
  EZWEL = 'ezwel',
}

export interface SalesChannelOrder {
  _id: string;
  uid: string;
  buyer: Buyer;
  channel: SalesChannelsType;
  createdAt: string;
  memo: Memo;
  origin: Origin;
  payment: Payment;
  purchaseNotificationDate: Date;
  refundNotificationDate: Date;
  refund?: SalesChannelOrderRefund;
  refunds?: SalesChannelOrderRefundItem[];
  plannedDate?: Date;
  plannedDates?: Date[];
  product: Product;
  purchase?: Purchase;
  purchases?: Purchase[];
  receiver: Receiver;
  seller: Seller;
  statuses: PaymentStatementStatus;
  updatedAt: string;
  sellerUser: SellerUser;
  completionDate?: Date;
  settlement?: PaymentStatementSettlement;
}

export interface Buyer {
  name: string;
  phone: string;
  nId: string;
}

export interface Memo {
  payment: string;
  shipping?: string;
  refund?: string;
  qna?: string;
  settlementPartner?: string;
}

export interface Origin {
  orderId: string;
  buyerName: string;
  receiverName: string;
  productName: string;
  option: string;
  quantity: number;
  paidAt: number;
  orderStatus: string;
  device: string;
  buyerId: string;
  shippingMethodRequested: string;
  orderNumber: string;
  productNumber: string;
  shippingMethod: string;
  shippingAgent: any;
  shippingInvoiceNumber: any;
  optionFee: number;
  shippingDate: number;
  orderDetailStatus: string;
  productType: string;
  productPrice: number;
  productDiscountPriceTotal: number;
  productDiscountPrice: number;
  orderPrice: number;
  gift: any;
  orderCheckDate: number;
  shippingDeadlineDate: number;
  shippingProceedDate: any;
  shippingInvoicePrintDate: any;
  shippingFeeFormType: any;
  shippingFeeNumber: any;
  shippingFeeType: any;
  shippingFeeTotal: number;
  shippingFeeAdditional: any;
  shippingFeedDiscount: number;
  sellerProductCode: any;
  sellerCode1: any;
  sellerCode2: any;
  receiverPhone1: string;
  receiverPhone2: any;
  address: any;
  addressBase: any;
  addressDetail: any;
  buyerPhone: string;
  addressPostCode: any;
  deliveryMemo: any;
  shippingLocation: any;
  paymentMethod: string;
  paymentCommissionType: string;
  paymentCommissionBillingType: string;
  naverPayOrderCommission: number;
  naverPayIncomeCommission: number;
  expectedSettlementAmount: number;
  referer: string;
  personalClearanceCode: any;
  orderedAt: number;
  subscribeAppliedCount: number;
  subscribeProcessCount: number;
  shippingReceiptDate: any;
}

export interface Payment {
  method: string;
  amount: number;
  billingAmount: number;
  paidAt: string;
}

export interface Product {
  id?: string;
  name: string;
}

export interface Purchase {
  name: string;
  fee: number;
  count: number;
  uid?: string;
  status?: string;
  date?: string;
  time?: string;
  yyyymmdd?: string;
  required?: boolean;
}

export interface SalesChannelOrderRefundItem extends Purchase {
  refundedAt: Date;
}

export interface Receiver {
  name: string;
  phone: string;
  phone2: any;
}

export interface Seller {
  id?: string;
  name?: string;
  phone?: string;
}

export interface Statuses {
  payment: string;
  refund: string;
  settlement: string;
}

export interface SellerUser {
  id: string;
  loginType: string;
  role: string;
  profile: Profile;
}

export interface Profile {
  name: string;
  phone: string;
  customerServicePhone: string;
}
